import { render, staticRenderFns } from "./navbarAdmin.vue?vue&type=template&id=04801d5a&scoped=true"
import script from "./navbarAdmin.vue?vue&type=script&lang=js"
export * from "./navbarAdmin.vue?vue&type=script&lang=js"
import style0 from "./navbarAdmin.vue?vue&type=style&index=0&id=04801d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04801d5a",
  null
  
)

export default component.exports